import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import { addSenderEmail, updateUserData } from '../../../../store/actions';
import { UPDATE_USER_DATA } from '../../../../store/auth/actionTypes';
import { checkIfLoading } from '../../../../store/functions';
import { ADD_SENDER_EMAIL } from '../../../../store/workspace/actionTypes';

function AddSenderModal({ modal, toggle }) {
    const [name, setName] = useState(null)
    const [email, setEmail] = useState(null)
    const dispatch = useDispatch()
    const [t] = useTranslation()

    const { addLoading } = useSelector(state => ({
        addLoading: checkIfLoading(state, ADD_SENDER_EMAIL)
    }))

    const onSubmit = () => {
        dispatch(addSenderEmail({ name, email }, toggle))
    }

    return (
        <>
            <Modal isOpen={modal} toggle={toggle} centered={true}>
                <ModalHeader className='px-4' toggle={toggle}></ModalHeader>
                <ModalBody className='pt-1 pb-3'>
                    <h3 className='mb-3 text-center'>{t('Add Sender Email')}</h3>
                    <div style={{ width: "80%" }} className="m-auto">
                        <div className='mb-3'>
                            <label>{t('Name')}</label>
                            <input type='text' value={name} onChange={(e) => setName(e.target.value)} className='form-control custom-border' placeholder={t('Enter name')} />
                        </div>
                        <div className='mb-3'>
                            <label>{t('email')}</label>
                            <input type='text' value={email} onChange={(e) => setEmail(e.target.value)} className='form-control custom-border' placeholder={t('Enter email')} />
                        </div>
                        <button type='submit' disabled={addLoading} className='btn click-btn green-btn btn-block mt-2' onClick={onSubmit}>
                            {
                                addLoading ? <Spinner size="sm" className="m-auto text-center" color="light" /> : t("Add Sender")
                            }
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}

export default AddSenderModal